import React, { useState } from "react";
import { Modal, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import api from "../../../../utils/api";

const AddActionModal = ({ show, onHide, onAddAction, isPortfolioData, roomId,isPrsuggections,setPrsuggections}) => {
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleModalHide = () => {
    reset(); // Reset form fields when modal hides
    setError(""); // Clear error on close
    onHide();
  };

  const onSubmit = async (data) => {
    setLoading(true);
    setError("");

    const payload = {
      clientid: roomId,
      pr_id: isPortfolioData?.prinfo?.portfolio_review_id,
      step: 52,
      action: "addcustomplan",
      customplan: data.newAction,

    };

    try {
      const response = await api.post(`advisor/updateprdata`, payload);
      console.log("API Response:", response.data);
      setPrsuggections(response?.data?.prsuggections);
      // Notify parent component
      reset(); // Reset form fields after success
      handleModalHide(); // Close modal on success
    } catch (err) {
      console.error("API Error:", err);
      setError("Failed to add action. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleModalHide} className="custom-sm-modal" centered>
      <Modal.Header closeButton style={{ backgroundColor: "#fff", border: "none" }}>
        <Modal.Title>Add Action Points</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="newAction">
            <Form.Label>Action</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter action point"
              className="custom-placeholder"
              {...register("newAction", { required: "Action is required" })}
              isInvalid={!!errors.newAction}
            />
            <Form.Control.Feedback type="invalid">
              {errors.newAction?.message}
            </Form.Control.Feedback>
          </Form.Group>

          {/* Show error message */}
          {error && <p className="text-danger mt-2">{error}</p>}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="lrgbutton uppercase w-100 text-white"
          type="submit"
          onClick={handleSubmit(onSubmit)}
          disabled={loading}
        >
          {loading ? <Spinner size="sm" animation="border" /> : "Add"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddActionModal;
